export const BRAND = {
  name: "The Neat Lab",
  tagline: "Formulated Cleanliness",
  logo: "/logo.png",
  phone: "973-613-0323",
  phoneLink: "tel:+19736130323",
  email: "info@theneatlabllc.com",
  emailLink: "mailto:info@theneatlabllc.com",
  bookUrl:
    "https://book.housecallpro.com/book/The-Neat-Lab-LLC/b12fd0f3cb054c8793e7dac8b4a120d0?v2=true",
  socials: {
    instagram: "https://www.instagram.com/theneatlabllc",
    facebook: "https://www.facebook.com/profile.php?id=61576517229485",
    tiktok: "https://www.tiktok.com/@theneatlabllc",
  },
};

export const SERVICES = [
  {
    id: "residential",
    title: "Residential Cleaning",
    blurb: "Standard, deep, and move in / out — dialed to lab-grade precision.",
    bullets: ["Standard refresh", "Deep clean", "Move in / move out"],
    image:
      "https://images.unsplash.com/photo-1758448500596-ce0e0239f1be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBsaXZpbmclMjByb29tJTIwY2xlYW58ZW58MHx8fHwxNzc3OTE5NTY1fDA&ixlib=rb-4.1.0&q=85",
    size: "lg",
    code: "R-01",
  },
  {
    id: "airbnb",
    title: "Rental & Airbnb Turnovers",
    blurb: "Done-for-you turnover: linen refresh, stocking, guest-ready staging.",
    bullets: ["Linen swap", "Stocking", "Guest-ready staging"],
    image:
      "https://images.unsplash.com/photo-1753605788101-04d1e653e74a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBiYXRocm9vbSUyMHByaXN0aW5lJTIwY2xlYW58ZW58MHx8fHwxNzc3OTE5NTY1fDA&ixlib=rb-4.1.0&q=85",
    size: "md",
    code: "R-02",
  },
  {
    id: "laundry",
    title: "Laundry Services",
    blurb: "Wash, fold, fragrance. Premium care for garments and linens.",
    bullets: ["Wash & fold", "Fragrance protocol"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/4084ec3b-9da1-44ac-a188-fcf31cb9d461/images/80053755829450fe1eb1486a027a6b24fd42372e87520f69272f25e18b19dd4f.png",
    size: "sm",
    code: "L-03",
  },
  {
    id: "events",
    title: "Post Party & Event Cleanups",
    blurb: "Post-event restoration — we come in after the guests leave and get your space spotless, fast and discreet.",
    bullets: ["Full post-event reset", "Trash & debris removal", "Deep surface clean"],
    image:
      "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
    size: "sm",
    code: "E-04",
  },
  {
    id: "pressure",
    title: "Exterior Surface & Window Cleaning",
    blurb: "Siding, driveways, porches, windows, and full pressure washing — streak-free finish guaranteed.",
    bullets: ["Siding & trim", "Driveways & porches", "Exterior windows"],
    image:
      "https://images.unsplash.com/photo-1759355787121-eaef014a501d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxob3VzZSUyMGV4dGVyaW9yJTIwY2xlYW4lMjBkcml2ZXdheXxlbnwwfHx8fDE3Nzc5MTk1NjV8MA&ixlib=rb-4.1.0&q=85",
    size: "md",
    code: "E-05",
    comingSoon: true,
  },
];

export const METRICS = [
  { label: "Avg. Turnover Time", value: "2.4h" },
  { label: "Eco-Safe Formulas", value: "100%" },
  { label: "5-Star Reviews", value: "250+" },
  { label: "On-Time Rate", value: "99.2%" },
];

export const PROCESS = [
  {
    step: "01",
    title: "Brief",
    desc: "Tell us the space, the scope, and the outcome you want.",
  },
  {
    step: "02",
    title: "Formulate",
    desc: "We calibrate a cleaning protocol — tools, products, timing.",
  },
  {
    step: "03",
    title: "Execute",
    desc: "Trained technicians deliver with methodical precision.",
  },
  {
    step: "04",
    title: "Verify",
    desc: "Quality pass, photo-log, and guaranteed satisfaction.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "The Neat Lab turned our Airbnb around in under three hours. Guests constantly comment on the cleanliness.",
    author: "Marisol R.",
    role: "Short-term rental host",
  },
  {
    quote:
      "A methodical, no-drama team. Our post-renovation home looked brand new — better than new, actually.",
    author: "Devon A.",
    role: "Homeowner, New Jersey",
  },
  {
    quote:
      "Booked them for a 90-person event reset. Back to pristine before we finished loading out.",
    author: "Priya K.",
    role: "Event coordinator",
  },
];
